<template>
<div class="inte-goodsList">
      <div class="group-sort">
        <div class="group-nav">
            <inteGroups :groups="clasList" @modeChange="modeChange" :noBor="true"></inteGroups>
            <div class="cart-box">
                <el-badge
                   :value="cartNums"
                   class="num"
                   
                   type="danger"
                   :max="99"
                   :hidden="!cartNums"
               >
                   <el-button type="primary"  icon="el-icon-shopping-cart-2" @click="goToCart" class="cart-btn">
                           购物车
                   </el-button>
               </el-badge>

            </div>
        </div>
        <div class="sear-sort">
            <div class="sort-nav">
                <div class="label">
                    排序方式：
                </div>
                <div class="sort-list">
                    <div class="clear-sort" @click="clearSort" :class="{'active':sort_k==''}">
                        综合排序
                    </div>
                    <div class="sort-item">
                        销量
                        <SortHandler @sortCutWay="sortCutWay" type="sales" :activeType="sort_k"></SortHandler>
                    </div>
                    <div class="sort-item">
                        积分
                        <SortHandler @sortCutWay="sortCutWay" type="price"  :activeType="sort_k"></SortHandler>
                    </div>
                </div>
            </div>
            <div class="search-box-container">
                <div class="search-box" >
                    <el-input placeholder="请输入内容"  v-model="search" @clear="searchResult" clearable @keyup.enter.native="searchResult">
                        <!-- <el-button slot="append" icon="el-icon-search" @click="searchResult"></el-button> -->
                    </el-input>
                    <el-button slot="append" type="primary" @click="searchResult">搜索</el-button>
                </div>
                
            </div>
            
        </div>
      </div>
     
     <div class="goods-list">
        <div class="card-box" v-for="(item,index) in goodsList" :key="index">
            <div  class="goods-card hnw-hov" >
                <div class="img-box"  @click="toGoodsInfo(item)" >
                    <img :src="item.images[0]" alt="">
                </div>
                <div class="card-fot">
                    <!-- 价格和仓位 -->
                    <div class="goods-name" :title="item.name+(item.oecode?item.oecode:'')">
                        <span class="brand">{{ item.oenaturebrand }}</span> {{item.name}} <span v-if="item.oecode">{{ item.oecode }}</span>
                    </div>
                    <div class="pri_warehouse">
                        
                        <div class="ware">
                            限量 {{item.stock}} 件
                        </div>
                        <el-input-number  v-model="item.goods_num"  :min="1" :max="Number(item.stock)"  size="mini"></el-input-number>
                    </div>
                    <div class="inte-price">
                        <div class="num">
                            <span v-if="$isCompany()">
                                {{ item.price }}
                            </span>
                            <span v-else>
                                会员可见
                            </span>
                        </div>
                        <div class="text">
                            积分
                        </div>
                    </div>
                    <div class="handle">
                        <div class="btn" @click.stop="buyNow(item)" >
                            兑换
                        </div>
                        <div class="btn" @click.stop="addToCart(item)" style=" background: #FF6600;">
                            加入购物车
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
     </div>
    <div class="paging">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[10,20,30]"
            :page-size.sync="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="Math.ceil(total)">
        </el-pagination>
    </div>  
</div>
</template>

<script>
import inteGroups from "./inteGroups.vue"
import SortHandler from "../../../components/SortHandler.vue"
import HnwOssImg from "../../../components/hnwOssImg.vue";
export default {
    data(){
        return{
            search: "", // 添加搜索关键字数据属性
            cartNums:0,
            groups:[
                {
                    title:"全部",
                    value:""
                },
                {
                    title:"礼品兑换",
                    value:"goods"
                },
                {
                    title:"配件兑换",
                    value:"parts"
                },
            ],
            clasList:[
                {
                    title:"全部",
                    value:""
                }
            ],
            
            page:1,
            limit:10,
            mode:"",
            total:20,
            goodsList:[],
            sort_k:"sort",
            sort_v:"desc",
            classify:""
        }
    },
    methods:{
        // 添加搜索方法
        searchResult() {
            this.page = 1; // 搜索时重置页码为1
            this.getList();
        },
        async handleSizeChange(val) {
            await this.getList()
            
            scrollTo(0,0)
        },
        clearSort(){
           this.sort_k = ""
           this.sort_v = ""
           this.getList()
        },
        sortCutWay(sort){
           this.sort_k = sort.sort_type
           this.sort_v = sort.sort_way
           this.getList()
        },
        handleCurrentChange(val) {
            this.getList()
        },
        modeChange(mode){
            this.classify = mode
            
            this.getList()
        },
        async getList(){
            let params ={
            }
            if(this.$route.params.id){
                params.shop = this.$route.params.id || "1780"
            }
            let res = await this.$api.getIntegrallist({
                limit:this.limit,
                page:this.page,
                mode:this.mode,
                classify:this.classify,
                sort_k:this.sort_k,
                sort_v:this.sort_v,
                name: this.search, // 添加搜索关键字参数
                ...params
            })
            
            this.total = res.count
            if(res.data){
                // 获取过滤品牌列表
                const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : []
                
                const filteredData = []
                
                for(let goods of res.data) {
                    if(goods.images){
                        try {
                            goods.images = JSON.parse(goods.images)
                            goods.goods_num = 1
                            
                            // 对于parts模式的商品进行品牌过滤
                            if(goods.mode=='parts'){
                                let resInfo = await this.$api.getIntegralInfo({
                                    id:goods.id,
                                    shop: "1780"
                                })
                                // 华诺威展示丹阳库存
                                goods.oecode = resInfo.info.oecode
                                goods.oenaturebrand = resInfo.info.oenaturebrand
                                
                                if(this.$store.state.is_sh!=1||this.$store.state.store_id=='1780'){
                                    goods.stock = resInfo.info.goods_stcids
                                }
                                
                                // 检查是否需要过滤品牌
                                let shouldFilter = false
                                if(exBrands.length > 0 && resInfo.info.oenaturebrand) {
                                    for(let brand of exBrands) {
                                        if(brand && resInfo.info.oenaturebrand.includes(brand.trim())) {
                                            shouldFilter = true
                                            break
                                        }
                                    }
                                }
                                
                                // 如果不需要过滤，则添加到结果中
                                if(!shouldFilter) {
                                    filteredData.push(goods)
                                }
                            } else {
                                // 非parts模式的商品直接添加
                                filteredData.push(goods)
                            }
                            
                        } catch (error) {
                            // 出错时也添加商品（保持原有逻辑）
                            filteredData.push(goods)
                        }
                    }
                }

                this.goodsList = filteredData
            } 
            
        },
        buyNow(goods){
            if(!this.$store.getters.isVisitor){
                this.$router.push("/integral/suborder/"+goods.id +"/"+goods.goods_num)
            }
        },
        // 添加加入购物车方法
        async addToCart(goods) {
            if (!this.$store.getters.isVisitor) {
                try {
                    // 构造购物车数据
                    // goods_id: goods.id,
                    // goods_name: goods.name,
                    // goods_price: goods.price,
                    // goods_num: goods.goods_num,
                    // goods_storage: goods.stock,
                    // parts_name: goods.name
                    const cartData = {
                        parts_id: goods.id, // 如果有parts_id的话
                        quantity:goods.goods_num
                    };
                    
                    // 调用API加入购物车
                    const res = await this.$api.addIntegralCart(cartData);
                    
                    if (res) {
                        this.$suMsg("已成功加入购物车");
                        // 调用购物车列表接口获取购物车数量
                        await this.getCartNums();
                    } else {
                        this.$erMsg("加入购物车失败");
                    }
                } catch (error) {
                    this.$erMsg("加入购物车时发生错误: " + error.message);
                }
            }
        },        
        toGoodsInfo(goods){
            console.log("goods",goods);
            
            if(this.$isCompany()){
                if(goods.isFilter){
                    return
                }
                let rou = '/integral/info'
                if(this.$route.params.id){
                    goods.preRou = "积分礼品"
                    localStorage.setItem("hnw-web-item-data",JSON.stringify(goods))
                    this.$emit("showInteInfo")
                }else{
                    goods.preRou = "积分礼品"
                    
                    localStorage.setItem("hnw-web-item-data",JSON.stringify(goods))
                    
                    this.$router.push(rou)
                }
            }
            
        },
        goToCart() {
            this.$router.push("/integral/cart");
        },
        // 获取购物车数量
        async getCartNums() {
            try {
                const res = await this.$api.getIntegralCart({});
                if (res && res.db) {
                    this.cartNums = res.db.length;
                }
            } catch (error) {
                console.error("获取购物车数量失败:", error);
            }
        }
    },
    async created(){
        this.getList()
        let res = await this.$api.getInGoodsClass({
            shop:this.$route.params.id||"1780"
        })

        if(res&&res.length>0){
            res.forEach(item=>{
                if(item.classify){
                    if(item.classify.includes('配件')){
                        // this.clasList.unshift({
                        //     title:item.classify,
                        //     value:item.classify
                        // })
                        this.clasList.splice(1, 0, {
                            title:item.classify,
                            value:item.classify
                        });
                    }else{
                        this.clasList.push({
                            title:item.classify,
                            value:item.classify
                        })
                    }
                }
            })
            
        }
        // 获取购物车数量
        await this.getCartNums();    
    },
    components:{
        inteGroups,
        SortHandler,
        HnwOssImg
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.inte-goodsList{
    .group-sort{
        .group-nav{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 5px;
            // background: #fff;
            .cart-btn {
                // margin-right: 10px;
                height: 32px;
                line-height: 32px;
                padding: 0 5px;
                width: 80px;
            }
            .cart-box{
               background: #fff; 
               height: 38px;
               display: flex;
               align-items: center;
               transform: translateY(-3px);
            }
        }
        .sear-sort {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            padding-right: 5px;
            background: #fff;
            .sort-nav{
                display: flex;
                // justify-content: flex-end;
                align-items: center;
                // padding: 8px 12px;
                background: #fff;
                height: 38px;
                line-height: 38px;
                background: #fff;
                padding-left: 20px;
                .label{
                    font-size: 14px;
                }
                .sort-list{
                    display: flex;
                    align-items: center;
                    >div{
                        padding: 0 12px;
                    }
                    .clear-sort{
                        cursor: pointer;
                    }
                    .active{
                        color: #3E84D6;
                    }
                    .sort-item{
                        display: flex;
                        align-items: center;
                    }
                }
            }
            .search-box-container {
                .search-box{
                    width: 400px;
                    
                    display: flex;
                    align-items: center;
                    // 调整输入框高度
                    .el-input__inner {
                        height: 32px;
                        line-height: 32px;
                        border-radius: 0;
                    }
                    
                    .el-button {
                        height: 32px;
                        min-width: 80px;
                        line-height: 32px;
                        padding: 0 5px;
                        box-sizing: border-box;
                    }
                }
                
            }
        }
        
    }
    .goods-list{
        // background: $backGray;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        padding: 15px 10px;
        .card-box{
            width: 20%;
            box-sizing: border-box;
            padding: 0 5px;
            .goods-card{
                padding: 10px 0;
                background: #fff;
                cursor: pointer;
                // height: 310px;
                box-sizing: border-box;
                display: flex;
                margin-bottom: 10px;
                flex-direction: column;
                border-radius: 4px;
                border: 1px solid #DCDCDC;
                .img-box{
                    // cursor: pointer;
                    height: 210px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        // width: 229px;
                        // height: 130px;
                        width: 210px;
                        height: 210px;
                    }
                }
                .card-fot{
                    box-sizing: border-box;
                    padding: 10px;
                    padding-bottom: 0;
                    .goods-name{
                        line-height: 22px;
                        min-height: 22px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        font-size: 14px;
                        color: #333333;
                        .brand{
                            color: #10317C;
                        }
                    }
                    .pri_warehouse{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-top: 8px;
                        .ware{
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                        }
                    }
                    .inte-price{
                        display: flex;
                        align-items: center;
                        padding: 8px 0;
                        .num{
                            font-family: MiSans;
                            font-weight: 800;
                            font-size: 24px;
                            color: #10317C;
                        }
                        .text{
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            margin-left: 10px;
                        }
                    }
                    .handle{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .btn{
                            width: 46%;
                            background: #10317C;
                            border-radius: 4px;
                            cursor: pointer;
                            text-align: center;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 16px;
                            color: #FFFFFF;
                            height: 40px;
                            line-height: 40px;
                        }
                    }
                }
            }
        }
        
        
    }
    
    .paging{
        display: flex;
        justify-content:right;
        padding-top: 10px;
        .el-pagination{

        }
    }
}
</style>